$(document).on("click", ".js-btn-toggle", function (e) {
  e.preventDefault();
  const $this = $(this);
  const elementToClose = $this.data("ref");
  const toggleClass = $this.data("class");
  const elementType = $this.data("type");

  $(elementToClose).toggleClass(toggleClass);

  if ($this.hasClass("modal__btn-close")) {
    $("body").removeClass("no-scroll");
  } else {
    if (elementType === "modal") {
      $("body").toggleClass("no-scroll");
    }
  }
});

$(document).on("click", ".js-toggle-reviews", function (e) {
  e.preventDefault();
  $(".js-modal-reviews").toggleClass("expanded");
  $("body").toggleClass("no-scroll");
});
